import React from 'react';
import { User } from "helpers/types";

export const UserContext = React.createContext<{
    data: User[];
    fetchData: () => void;
}>({
    data: [],
    fetchData: () => { },
});